"use client";
import React, { useState, useMemo, useCallback } from "react";
import { BANKER, LOCATION } from "@/contants";
// import moment from "moment-timezone";
import "./index.scss";
import NoData from "@/components/client/NoData";
import { useIsMobile } from "@/lib/isMobile";
import { useLiveScores } from "@/context/LiveScoresContext";
import dayjs from 'dayjs'; // Core Day.js
import utc from 'dayjs/plugin/utc.js'; // UTC plugin
import timezone from 'dayjs/plugin/timezone.js'; // Timezone plugin
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(customParseFormat);

const CompareOddTable = ({ matchId, data, match }) => {
  const [companyId, setCompanyId] = useState(BANKER[0].value);
  const [timeMatch, setTimeMatch] = useState(false);
  const [location, setLocation] = useState(LOCATION[0].slug);
  const [timeMatchBg, setTimeMatchBg] = useState(LOCATION[0].bg);
  const isMobile = useIsMobile();
  //const oddLive = useSelector((state => state.matchReducer.oddLiveScore));

  const dataLive = useLiveScores() || {};

  const oddLive = useMemo(() => {
    let dataLiveScore = {};
    if (dataLive.liveOdd !== undefined && dataLive.liveOdd?.length > 0) {
      dataLiveScore = dataLive.liveOdd.find(
        (liveOdds) => Number(liveOdds.matchId) === Number(matchId)
      );
    }

    return dataLiveScore;
  }, [dataLive]);

  const oddEuropeMapByCompanyId = useMemo(() => {
    let result = [];
    const europeOddsLive = oddLive?.data?.europeOdds
      ? oddLive?.data?.europeOdds?.find((item) => item.companyId === companyId)
      : null;

    if (europeOddsLive) {
      result = [
        europeOddsLive,
        ...data?.liveEuropeOdds?.filter((item) => item.companyId === companyId),
      ];
    } else {
      result = data?.liveEuropeOdds?.filter(
        (item) => item.companyId === companyId
      );
    }
    return result;
  }, [data?.liveEuropeOdds, companyId, oddLive]);

  const oddHandicapHalfMapByCompanyId = useMemo(() => {
    let result = [];

    const handicapHalfOddsLive = oddLive?.data?.handicapHalf
      ? oddLive?.data?.handicapHalf?.find(
          (item) => item.companyId === companyId
        )
      : null;

    if (handicapHalfOddsLive) {
      result = [
        handicapHalfOddsLive,
        ...data?.liveHandicapHalfOdds?.filter(
          (item) => item.companyId === companyId
        ),
      ];
    } else {
      result = data?.liveHandicapHalfOdds?.filter(
        (item) => item.companyId === companyId
      );
    }
    return result;
  }, [data?.liveHandicapHalfOdds, companyId, oddLive]);

  const oddOverUnderMapByCompanyId = useMemo(() => {
    let result = [];
    const liveOverUnder = oddLive?.data?.overUnder
      ? oddLive?.data?.overUnder?.find((item) => item.companyId === companyId)
      : null;

    if (liveOverUnder) {
      result = [
        liveOverUnder,
        ...data?.liveOverUnderOdds?.filter(
          (item) => item.companyId === companyId
        ),
      ];
    } else {
      result = data?.liveOverUnderOdds?.filter(
        (item) => item.companyId === companyId
      );
    }
    return result;
  }, [data?.liveOverUnderOdds, companyId, oddLive]);

  const oddOverUnderHalfMapByCompanyId = useMemo(() => {
    let result = [];

    const overUnderHalf = oddLive?.data?.overUnderHalf
      ? oddLive?.data?.overUnderHalf?.find(
          (item) => item.companyId === companyId
        )
      : null;

    if (overUnderHalf) {
      result = [
        overUnderHalf,
        ...data?.liveOverUnderHalfOdds?.filter(
          (item) => item.companyId === companyId
        ),
      ];
    } else {
      result = data?.liveOverUnderHalfOdds?.filter(
        (item) => item.companyId === companyId
      );
    }

    return result;
  }, [data?.liveOverUnderHalfOdds, companyId, oddLive]);

  const oddHandicapMapByCompanyId = useMemo(() => {
    let result = [];

    const handicapOdds = oddLive?.data?.handicap
      ? oddLive?.data?.handicap?.find((item) => item.companyId === companyId)
      : null;

    if (handicapOdds) {
      result = [
        handicapOdds,
        ...data?.liveHandicapOdds?.filter(
          (item) => item.companyId === companyId
        ),
      ];
    } else {
      result = data?.liveHandicapOdds?.filter(
        (item) => item.companyId === companyId
      );
    }
    return result;
  }, [data?.liveHandicapOdds, companyId, oddLive]);

  const oddHandicapTimeMatch = useMemo(() => {
    if (!timeMatch) {
      return oddHandicapMapByCompanyId;
    } else {
      return oddHandicapHalfMapByCompanyId;
    }
  }, [timeMatch, companyId]);

  const oddOverUnderTimeMatch = useMemo(() => {
    if (!timeMatch) {
      return oddOverUnderMapByCompanyId;
    } else {
      return oddOverUnderHalfMapByCompanyId;
    }
  }, [timeMatch, companyId]);

  const differenceInMinutes = useCallback((matchTime, eventTime) => {
    const time1 = dayjs.unix(Number(matchTime)).tz("Asia/Ho_Chi_Minh");
    const time2 = dayjs.unix(Number(eventTime)).tz("Asia/Ho_Chi_Minh");

    // Tính số phút chênh lệch
    const minutes = dayjs.duration(time2.diff(time1)).asMinutes();

    // Xử lý trường hợp số phút trước trận đấu hoặc bù giờ
    if (minutes < 0) {
      return `Trước trận đấu`;
    } else if (minutes > 90) {
      return "Kết thúc";
    } else {
      return `${Math.ceil(minutes)}'`;
    }
  }, []);

  const handleChangeCompanyId = (value) => {
    setCompanyId(value);
  };

  const handleChangeTime = (value) => {
    setTimeMatch(value);
  };

  const handleChangeLocation = (item) => {
    setLocation(item.slug);
    setTimeMatchBg(item.bg);
  };

  return (
    <React.Fragment>
      <div className="hidden @lg:flex gap-1 mt-3 mb-3 justify-between">
        <div className="flex gap-1 items-center justify-center">
          {BANKER.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                handleChangeCompanyId(item.value);
              }}
              className={`${
                companyId === item.value
                  ? "bg-blur-gray text-[#FFFFFF] dark:bg-button-blue-bet"
                  : "bg-header-blue text-blur-gray dark:bg-dark-slate"
              } mr-1 font-xs font-semi-bold rounded-full px-2 py-1 hover:cursor-pointer`}
            >
              {item.name}
            </div>
          ))}
        </div>
        <div className="items-center justify-center">
          <span
            onClick={() => {
              handleChangeTime(false);
            }}
            className={`p-2 hover:cursor-pointer rounded-md ${
              !timeMatch ? "bg-gradient-start" : "bg-white dark:bg-dark-slate text-blur-gray"
            }`}
          >
            Cả trận
          </span>
          <span
            onClick={() => {
              handleChangeTime(true);
            }}
            className={`p-2 hover:cursor-pointer rounded-md ${
              timeMatch ? "bg-gradient-start" : "bg-white dark:bg-dark-slate text-blur-gray"
            }`}
          >
            Hiệp 1
          </span>
        </div>
      </div>
      <div className="flex justify-between align-center @lg:hidden mt-2">
        <div className="flex my-2">
          {LOCATION.map((item) => (
            <div
              key={item.slug}
              onClick={() => {
                handleChangeLocation(item);
              }}
              className={`${
                location === item.slug
                  ? "bg-button-blue-bet text-[#FFFFFF]"
                  : "bg-header-blue text-blur-gray"
              } mr-1 font-xs font-semi-bold rounded-full px-2 py-1 hover:cursor-pointer`}
            >
              {item.name}
            </div>
          ))}
        </div>
        {/* <div className="w-[100px]">
          <PopupButton data={BANKER} />
        </div> */}

        <select
          className="p-2 rounded shadow-md border border-button-blue-bet"
          onChange={(event) => {
            handleChangeCompanyId(event.target.value);
          }}
        >
          {BANKER.map((item, index) => (
            <option value={item.value} key={"selectBanker" + index}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex @lg:hidden">
        <span
          onClick={() => {
            handleChangeTime(false);
          }}
          className={`px-3 py-1 hover:cursor-pointer rounded-t-md mr-2 ${
            !timeMatch ? timeMatchBg : "bg-header-blue text-blur-gray"
          }`}
        >
          Cả Trận
        </span>
        <span
          onClick={() => {
            handleChangeTime(true);
          }}
          className={`px-3 py-1 hover:cursor-pointer rounded-t-md ${
            timeMatch ? timeMatchBg : "bg-header-blue text-blur-gray"
          }`}
        >
          Hiệp 1
        </span>
      </div>
      <div className="@lg:flex gap-1">
        <div
          className={`overflow-auto scrollbar-hidden h-[500px] ${
            !isMobile || location === "chau-a" ? "block" : "hidden"
          }`}
        >
          <table className="min-w-full table-auto border-collapse">
            {/* FOR DESKTOP */}
            <thead className={isMobile ? "hidden" : ""}>
              <tr className="bg-gray-200 text-gray-700">
                <th
                  rowSpan={2}
                  className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white "
                >
                  Trạng thái
                </th>
                <th
                  rowSpan={2}
                  className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white "
                >
                  Tỉ số
                </th>
                <th
                  colSpan="3"
                  className="border px-2 py-2 text-center bg-aqua-mint dark:bg-pure-black dark:text-white"
                >
                  Tỷ lệ châu Á
                </th>
                <th
                  rowSpan={2}
                  className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white "
                >
                  Thời gian
                </th>
              </tr>
              <tr className="bg-green-200">
                <th className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white ">
                  Chủ
                </th>
                <th className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white ">
                  HDC
                </th>
                <th className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white ">
                  Khách
                </th>
              </tr>
            </thead>
            {/* FOR MOBILE */}
            <thead className={!isMobile ? "hidden" : ""}>
              <tr className="bg-gray-200 text-gray-700">
                <th className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white ">
                  Trạng thái
                </th>
                <th className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white ">
                  Tỉ số
                </th>
                <th className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white ">
                  Chủ
                </th>
                <th className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white ">
                  HDC
                </th>
                <th className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white ">
                  Khách
                </th>
                <th className="border px-2 py-2 text-center bg-pale-aqua  dark:bg-pale-dark-aqua dark:text-white ">
                  Thời gian
                </th>
              </tr>
            </thead>
            <tbody>
              {oddHandicapTimeMatch?.length > 0 &&
                oddHandicapTimeMatch?.map((item, index) => (
                  <tr key={index} className={`bg-white ${index % 2 == 0 ? 'dark:bg-dark-slate' : 'dark:bg-pure-black'}`}>
                    <td className="border px-1 py-2 text-center">
                      {differenceInMinutes(match.matchTime, item.changeTime)}
                    </td>
                    <td className="border px-1 py-2 text-center">
                      {item.score}
                    </td>
                    <td className={'px-1 py-2 text-center'}>
                      <div>
                        <span
                          className={`text-xs ${
                            item.initialHomeTrend === "increased"
                              ? "text-medium-green"
                              : "text-vibrant-red"
                          }`}
                        >
                          {item.instantHome}
                        </span>
                        {item.initialHomeTrend === "increased" ? (
                          <span className={`text-xs text-medium-green`}>
                            ▲
                          </span>
                        ) : (
                          <span className={`text-xs text-vibrant-red`}>
                            ▼
                          </span>
                        )}
                      </div>
                    </td>
                    <td className={'px-1 py-2 text-center'}>
                      <div>{item.instantHandicap}</div>
                    </td>
                    <td className={'px-1 py-2 text-center'}>
                      <div>
                        <span
                          className={`text-xs ${
                            item.initialAwayTrend === "increased"
                              ? "text-medium-green"
                              : "text-vibrant-red"
                          }`}
                        >
                          {item.instantAway}
                        </span>
                        {item.initialAwayTrend === "increased" ? (
                          <span className={`text-xs text-medium-green`}>
                            ▲
                          </span>
                        ) : (
                          <span className={`text-xs text-vibrant-red`}>
                            ▼
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="border px-1 py-2 text-center">
                      {dayjs
                        .tz(Number(item.changeTime) * 1000, "Asia/Ho_Chi_Minh")
                        .format("MM-DD HH:mm")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {oddHandicapTimeMatch?.length === 0 && <NoData />}
        </div>
        <div
          className={`overflow-auto scrollbar-hidden h-[500px] ${
            !isMobile || location === "tai-xiu" ? "block" : "hidden"
          }`}
        >
          <table className="min-w-full table-auto border-collapse">
            {/* FOR DESKTOP */}
            <thead className={isMobile ? "hidden" : ""}>
              <tr className="bg-gray-200 text-gray-700">
                <th
                  rowSpan={2}
                  className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white"
                >
                  Trạng thái
                </th>
                <th
                  rowSpan={2}
                  className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white"
                >
                  Tỉ số
                </th>
                <th
                  colSpan="3"
                  className="border px-2 py-2 text-center bg-golden-sun dark:bg-pure-black dark:text-white"
                >
                  Tỷ lệ Tài Xỉu
                </th>
                <th
                  rowSpan={2}
                  className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white"
                >
                  Thời gian
                </th>
              </tr>
              <tr className="bg-green-200">
                <th className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white">
                  Chủ
                </th>
                <th className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white">
                  HDC
                </th>
                <th className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white">
                  Khách
                </th>
              </tr>
            </thead>
            {/* FOR MOBILE */}
            <thead className={!isMobile ? "hidden" : ""}>
              <tr className="bg-gray-200 text-gray-700">
                <th className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white">
                  Trạng thái
                </th>
                <th className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white">
                  Tỉ số
                </th>
                <th className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white">
                  Chủ
                </th>
                <th className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white">
                  HDC
                </th>
                <th className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white">
                  Khách
                </th>
                <th className="border px-2 py-2 text-center bg-yellow-pastel dark:bg-yellow-dark-pastel dark:text-white">
                  Thời gian
                </th>
              </tr>
            </thead>
            <tbody>
              {oddOverUnderTimeMatch?.length > 0 &&
                oddOverUnderTimeMatch?.map((item, index) => (
                  <tr key={index} className={`bg-white ${index % 2 == 0 ? 'dark:bg-dark-slate' : 'dark:bg-pure-black'}`}>
                    <td className="border px-1 py-2 text-center">
                      {differenceInMinutes(match.matchTime, item.changeTime)}
                    </td>
                    <td className="border px-1 py-2 text-center">
                      {item.score}
                    </td>
                    <td className={'px-1 py-2 text-center'}>
                      <div>
                        <span
                          className={`text-xs ${
                            item.initialOverTrend === "increased"
                              ? "text-medium-green"
                              : "text-vibrant-red"
                          }`}
                        >
                          {item.instantOver}
                        </span>
                        {item.initialOverTrend === "increased" ? (
                          <span className={`text-xs text-medium-green`}>
                              ▲
                            </span>
                        ) : (
                          <span className={`text-xs text-vibrant-red`}>
                              ▼
                            </span>
                        )}
                      </div>
                    </td>
                    <td className={'px-1 py-2 text-center'}>
                      <div>{item.instantHandicap}</div>
                    </td>
                    <td className={'px-1 py-2 text-center'}>
                      <div>
                          <span
                            className={`text-xs ${
                              item.initialUnderTrend === "increased"
                                ? "text-medium-green"
                                : "text-vibrant-red"
                            }`}
                          >
                            {item.instantUnder}
                          </span>
                        {item.initialUnderTrend === "increased" ? (
                          <span className={`text-xs text-medium-green`}>
                              ▲
                            </span>
                        ) : (
                          <span className={`text-xs text-vibrant-red`}>
                              ▼
                            </span>
                        )}
                      </div>
                    </td>
                    <td className="border px-1 py-2 text-center">
                      {dayjs
                        .tz(Number(item.changeTime) * 1000, "Asia/Ho_Chi_Minh")
                        .format("MM-DD HH:mm")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {oddOverUnderTimeMatch?.length === 0 && <NoData/>}
        </div>
        <div
          className={`overflow-auto scrollbar-hidden h-[500px] ${
            !isMobile || location === "chau-au" ? "block" : "hidden"
          }`}
        >
        <table className="min-w-full table-auto border-collapse">
            {/* FOR DESKTOP */}
            <thead className={isMobile ? "hidden" : ""}>
              <tr className="bg-gray-200 text-gray-700">
                <th
                  rowSpan={2}
                  className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white"
                >
                  Trạng thái
                </th>
                <th
                  rowSpan={2}
                  className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white"
                >
                  Tỉ số
                </th>
                <th
                  colSpan="3"
                  className="border px-2 py-2 text-center bg-sky-blue dark:bg-pure-black dark:text-white"
                >
                  Tỷ lệ châu Âu
                </th>
                <th
                  rowSpan={2}
                  className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white"
                >
                  Thời gian
                </th>
              </tr>
              <tr className="bg-green-200">
                <th className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white">
                  Chủ
                </th>
                <th className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white">
                  HDC
                </th>
                <th className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white">
                  Khách
                </th>
              </tr>
            </thead>
            {/* FOR MOBILE */}
            <thead className={!isMobile ? "hidden" : ""}>
              <tr className="bg-gray-200 text-gray-700">
                <th className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white">
                  Trạng thái
                </th>
                <th className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white">
                  Tỉ số
                </th>
                <th className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white">
                  Chủ
                </th>
                <th className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white">
                  HDC
                </th>
                <th className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white">
                  Khách
                </th>
                <th className="border px-2 py-2 text-center bg-cool-mist  dark:bg-cool-dark-mist dark:text-white">
                  Thời gian
                </th>
              </tr>
            </thead>
            <tbody>
              {oddEuropeMapByCompanyId?.length > 0 &&
                oddEuropeMapByCompanyId.map((item, index) => (
                  <tr key={index} className={`bg-white ${index % 2 == 0 ? 'dark:bg-dark-slate' : 'dark:bg-pure-black'}`}>
                    <td className="border px-1 py-2 text-center">
                      {differenceInMinutes(match.matchTime, item.changeTime)}
                    </td>
                    <td className="border px-1 py-2 text-center">
                      {item.score}
                    </td>
                    <td className={'px-1 py-2 text-center'}>
                      <div>
                          <span
                            className={`text-xs ${
                              item.initialHomeTrend === "increased"
                                ? "text-medium-green"
                                : "text-vibrant-red"
                            }`}
                          >
                            {item.instantHome}
                          </span>
                        {item.initialHomeTrend === "increased" ? (
                          <span className={`text-xs text-medium-green`}>
                              ▲
                            </span>
                        ) : (
                          <span className={`text-xs text-vibrant-red`}>
                              ▼
                            </span>
                        )}
                      </div>
                    </td>
                    <td className={'px-1 py-2 text-center'}>
                      <div>{item.instantDraw}</div>
                    </td>
                    <td className={'px-1 py-2 text-center'}>
                      <div>
                          <span
                            className={`text-xs ${
                              item.initialAwayTrend === "increased"
                                ? "text-medium-green"
                                : "text-vibrant-red"
                            }`}
                          >
                            {item.instantAway}
                          </span>
                        {item.initialAwayTrend === "increased" ? (
                          <span className={`text-xs text-medium-green`}>
                              ▲
                            </span>
                        ) : (
                          <span className={`text-xs text-vibrant-red`}>
                              ▼
                            </span>
                        )}
                      </div>
                    </td>
                    <td className="border px-1 py-2 text-center">
                      {dayjs
                        .tz(Number(item.changeTime) * 1000, "Asia/Ho_Chi_Minh")
                        .format("MM-DD HH:mm")}
                    </td>
                  </tr>
                ))}
            </tbody>
        </table>
          {oddEuropeMapByCompanyId?.length === 0 && <NoData/>}
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(CompareOddTable);
